import Barba from 'barba.js';
import { $document, $window, $html, $body } from '../utils/environment';
import * as transitions from '../global/transitions';

/**
 * Module: Transitions Manager
 */
export default class {

    /**
     * Constructeur.
     *
     * @param {object} options  paramètres du constructeur
     * @return {void}
     */
    constructor(options) {
        // initialisation des variables
        this.$dom = {};

        // initialisation de `TransitionsManager`
        this.init();
    }

    /**
     * Initialisation de `TransitionsManager`.
     *
     * @return {void}
     */
    init() {
        // initialisation
        this.$dom.links = [];

        // initialisation des événements
        this.initEvents();

        // chargement de barba.js
        this.loadBarba();

        //document.addEventListener('DOMContentLoaded', this.loadBarba);
    }

    /**
     * Initialisation des événements.
     *
     * @return {void}
     */
    initEvents() {
        this.events = {};

        // événement: goTo
        this.events.goTo = this.goTo.bind(this);
        $document.on('goTo.TransitionsManager', this.events.goTo);
    }

    /**
     * Réinitialisation des évévenemnts sur les
     * liens présents dans le content.
     *
     * @return {void}
     */
    resetLinksEvents() {
        // suppression des événements si déjà existant
        if (this.events.links !== undefined) {
            for (let i = 0; i < this.$dom.links.length; i++) {
                this.$dom.links[i].removeEventListener('click', this.events.links[i]);
            }
        }

        this.events.links = [];
        this.$dom.links = [];

        // ajouter un event sur chaque liens afin de vérifier
        // son status dans barba (ex: si déjà actif)
        this.$dom.links = document.querySelectorAll('a[href]');
        for (let i = 0; i < this.$dom.links.length; i++) {
            this.events.links[i] = this.checkLinksClicked.bind(this);
            this.$dom.links[i].addEventListener('click', this.events.links[i]);
        }
    }

    /**
     * Vérification du lien cliqué par l'utilisateur.
     * Suite à un bug présent dans barba sur les pages
     * courantes (https://github.com/luruke/barba.js/issues/34),
     * si la page est identique au lien cliqué, on arrête la
     * propagation de l'événement est on remonte vers le haut de page.
     *
     * @param {object} event  événement du lien cliqué
     * @return {void}
     */
    checkLinksClicked(event) {
        if (event.currentTarget.href === window.location.href) {
            event.preventDefault();
            //event.stopPropagation();

            // fermer toutes les header navigations
            $document.trigger('rebuild.HeaderCategories');

            // remonter la page vers le haut
            $document.trigger('scrollTop.Scroll');

            // fermer la navigation mobile
            $document.trigger({ type: 'close.HeaderNavigation' });
        }
    }

    /**
     * Utiliser barba pour naviguer vers une nouvelle
     * page. Cela permet de pouvoir jouer la transition.
     *
     * @param {object} event  événement contenant la nouvelle url
     * @return {void}
     */
    goTo(event) {
        Barba.Pjax.goTo(event.location);
    }

    /**
     * Chargement de la librairie barba.
     *
     * @return {void}
     */
    loadBarba() {
        // ativer le cache XHR
        Barba.Pjax.cacheEnabled = true;

        // configuration de barba
        Barba.Pjax.Dom.dataNamespace = 'namespace';
        Barba.Pjax.Dom.wrapperId = 'js-barba-wrapper';
        Barba.Pjax.Dom.containerClass = 'js-barba-container';
        Barba.Pjax.ignoreClassLink = 'js-no-page-transitions';

        // activer le préchargement des pages
        // Barba.Prefetch.init();

        // définir les transitions de pages
        Barba.Pjax.getTransition = () => {
            let transition = transitions.DefaultTransition;
            // if (this.route === 'nav-categories' || this.route === 'nav-categories-choice') {
            //     transition = transitions.NavigationCategoriesTransition;
            // }

            return transition;
        }

        // the user click on a link elegible for PJAX
        Barba.Dispatcher.on('linkClicked', (currentStatus, oldStatus, container) => {
            this.route = currentStatus.getAttribute('data-route');

            // if (this.route === 'nav-categories-choice') {
            //     $(currentStatus).parents('.js-navigation-item').addClass('is-fire');
            // }
            // if (this.route === 'nav-categories') {
            //     $(currentStatus).addClass('is-fire');
            // }
        });

        // the link has just been changed
        // Barba.Dispatcher.on('initStateChange', currentStatus => {
        //     console.log('[BARBA] initStateChange');
        // });

        // the new container has been loaded and injected in the wrapper
        Barba.Dispatcher.on('newPageReady', (currentStatus, prevStatus, container, currentHTML) => {
            let scripts;
            let s;

            // Fetch any inline script elements.
            scripts = container.querySelectorAll([
                'script[type="text/javascript"]',
                'script[type="module"]',
                'script:not([type])',
            ].join(','));
            if (scripts !== undefined) {
                for (let i = 0; i < scripts.length; i += 1) {
                    (0, eval)(scripts[i].innerHTML);
                }
            }

            /**
             * Execute any third party features.
             */

            // Google Analytics
            if (window.ga && !$html.data('debug')) {
                ga('send', 'pageview');
            }

            this.resetLinksEvents();
        });

        // the transition has just finished and the old Container has been removed from the DOM
        // Barba.Dispatcher.on('transitionCompleted', (currentStatus, oldStatus) => {
        //     console.log('[BARBA] transitionCompleted');
        // });

        // lancement de barba
        Barba.Pjax.start();
    }

    /**
     * Déstructeur.
     *
     * @return {void}
     */
    destroy() {
        // supprimer les événements
        for (let i = 0; i < this.$dom.links.length; i++) {
            this.$dom.links[i].removeEventListener('click', this.events.links[i]);
        }
        $document.off('goTo.TransitionsManager', this.events.goTo);
        this.$el.off();

        // initialisation des variables
        this.events = {};
        this.$dom = {};
    }
}
